import { useRef, useState } from 'react'

import amigosVideoPoster from '../../../../assets/img/Portada vídeo_Amigas.jpg'
import fiestaMenstrualVideo from '../../../../assets/videos/fiesta_menstrual.mp4'
import SubHeading from '../../../subHeading/SubHeading'

import './beingpart.css'

const BeingPart = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)
  const videoRef = useRef(null)

  const handlePlayVideo = async () => {
    if (!videoRef.current) {
      return
    }

    try {
      await videoRef.current.play()
      setIsVideoPlaying(true)
    } catch (error) {
      setIsVideoPlaying(false)
    }
  }

  return (
    <section
      className='friends-hero section__padding'
      aria-labelledby='friends-hero-title'
    >
      <div className='friends-hero__layout'>
        <div className='friends-hero__copy'>
          <p className='friends-hero__eyebrow'>Red</p>
          <div id='friends-hero-title' className='friends-hero__heading'>
            <SubHeading title='¿Quieres apoyar nuestra asociación?' />
          </div>
          <div className='friends-hero__divider' aria-hidden='true'></div>
          <p className='friends-hero__text'>
            Desde el quinto eje de intervención, “Red”, buscamos articular y
            fortalecer la colaboración y el apoyo entre activistas, educadoras,
            artesanas, artistas, profesionales sanitarias, terapeutas y todas
            aquellas personas vinculadas a la cultura menstrual.
          </p>
          <p className='friends-hero__text'>
            Conviértete en Amiga y únete a esta red de conocimientos, apoyo,
            saberes y acciones compartidas, que impulsa la educación, la
            visibilización y la transformación ecosocial en torno a la
            menstruación, el ciclo y el climaterio.
          </p>
        </div>

        <div className='friends-hero__media'>
          <div className='friends-hero__image-frame'>
            <video
              ref={videoRef}
              className='friends-hero__video'
              poster={amigosVideoPoster}
              controls={isVideoPlaying}
              preload='metadata'
              onPlay={() => setIsVideoPlaying(true)}
              onEnded={() => setIsVideoPlaying(false)}
              aria-label='Video sobre la red de amigas de La Vida en Rojo'
            >
              <source src={fiestaMenstrualVideo} type='video/mp4' />
              Tu navegador no soporta la reproducción de video.
            </video>

            {!isVideoPlaying && (
              <button
                type='button'
                className='friends-hero__play-button'
                onClick={handlePlayVideo}
                aria-label='Reproducir video de la red de amigas'
              >
                <span aria-hidden='true' className='friends-hero__play-icon'>
                  ▶
                </span>
                Reproducir video
              </button>
            )}

            <div className='friends-hero__image-overlay' aria-hidden='true'></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BeingPart
